/**
 * Pricing page scripts
 *
 * @since 1.3.8
 */
document.addEventListener('DOMContentLoaded', function () {
    const pricingPlanButtons = document.querySelectorAll('.pricing-plan-buttons button');
    const annualPlans = document.querySelector('.pricing-plan-annual');
    const lifetimePlans = document.querySelector('.pricing-plan-lifetime');

    pricingPlanButtons.forEach((button) => {
        button.addEventListener('click', () => {
            const plantType = button.dataset.type;
            pricingPlanButtons.forEach((button) => button.classList.remove('active'));
            button.classList.add('active');

            if (plantType === 'annual') {
                annualPlans.classList.remove('d-none');
                lifetimePlans.classList.add('d-none');
            } else {
                annualPlans.classList.add('d-none');
                lifetimePlans.classList.remove('d-none');
            }
        });
    });
});
